
























import {Component, Prop, Vue} from 'vue-property-decorator';
import MeterReadingCsvMapping from '@/data/models/meter-reading-csv-mapping';
import Button from '@/components/commons/Button.vue';
import {LIMIT_ROW_IMPORT} from '@/constants';

@Component({
  components: {Button},
})
export default class ImportCSV extends Vue {
  @Prop({required: true})
  meterReading: MeterReadingCsvMapping;

  @Prop({required: true})
  opened: boolean;

  file: File = null;
  csvLengthWarning: string = null;

  get dialog(): boolean {
    return this.opened;
  }

  set dialog(value: boolean) {
    this.$emit('close', value);
    this.file = null;
    this.csvLengthWarning = null;
  }

  handleImport(): void {
    this.file.text().then((text) => {
      const csvLength: number = text.match(/\r?\n/g).length - this.meterReading.headerLinesCount;
      if (csvLength > LIMIT_ROW_IMPORT) {
        this.csvLengthWarning = this.$t('detailMeter.lengthWarning', {length: csvLength}).toString();
      }
    });
  }

  sendFile(): Promise<void> {
    this.$store.commit("showLoader", true);
    return this.file.text().then((text) => {

      return this.$dao.meters.importCSV(this.meterReading.filename, text).then(
        (result) => {
          if (result != null) {
            this.dialog = false;
            this.$dialog.confirm({title: this.$t('detailMeter.successImport').toString(), text: this.$t('detailMeter.imported', {imported: result.inserted, total: result.total, details: JSON.stringify(result.details, null, ' '), metersCount: Object.keys(result.details).length}).toString()});
            this.$emit('imported');
          } else {
            throw 'err';
          }
        },
      ).catch(() => {
        this.$dialog.error({text: this.$t('errors.import').toString(), title: this.$t('errors.error').toString(), actions: ['Fermer']});
      }).finally(() => {
        this.$store.commit("showLoader", false);
        this.csvLengthWarning = null;
      });
    });
  }

}
